import { render, staticRenderFns } from "./modal-wnd.vue?vue&type=template&id=163d6dba&scoped=true&lang=pug"
import script from "./modal-wnd.vue?vue&type=script&lang=js"
export * from "./modal-wnd.vue?vue&type=script&lang=js"
import style0 from "./modal-wnd.vue?vue&type=style&index=0&id=163d6dba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d6dba",
  null
  
)

export default component.exports